import React from 'react';

function HowToBtn(props) {
    return (
        <button id='howToPlayBtn' className="rounded-full absolute max-w-2 top-1 right-1 sm:top-3 sm:right-3 font-bold text-2xl sm:text-3xl lg:text-5xl sm:font-bold rounded filter drop-shadow-lg shadow-2xl shadow-inner" onClick={props.open}>
            <p className='border-8 border-gray-300 rounded-full h-16 w-16 md:h-20 md:w-20 flex items-center justify-center text-gray-300 shadow-2xl'>?</p>
        </button>
    );
  
}

export default HowToBtn;